import styled from '@emotion/styled';

const FILLED = '#1a2647';
const EMPTY = '#d4d7de';

const STAR_PATH =
  'M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z';

type RecruiterStarsProps = {
  filledCount: number;
  periodLabel?: string;
};

const MAX_RECRUITER_STARS = 6;

const RecruiterStars = ({ filledCount, periodLabel }: RecruiterStarsProps) => {
  const filled = Math.min(
    MAX_RECRUITER_STARS,
    Math.max(0, Math.round(filledCount)),
  );

  const ariaLabel = periodLabel
    ? `${periodLabel} recruiting rating: ${filled} out of ${MAX_RECRUITER_STARS} stars`
    : `Recruiter rating: ${filled} out of ${MAX_RECRUITER_STARS} stars`;

  return (
    <Row role="img" aria-label={ariaLabel}>
      {Array.from({ length: MAX_RECRUITER_STARS }, (_, i) => (
        <StarSlot key={i} $filled={i < filled}>
          <StarSvg
            $filled={i < filled}
            viewBox="0 0 24 24"
            aria-hidden
            focusable="false">
            <path d={STAR_PATH} />
          </StarSvg>
        </StarSlot>
      ))}
    </Row>
  );
};

const STAR_OVERLAP_PX = 5;

const Row = styled.div`
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  white-space: nowrap;
`;

const StarSlot = styled.div<{ $filled: boolean }>`
  display: flex;
  align-items: center;
  position: relative;
  z-index: ${(p) => (p.$filled ? 2 : 1)};

  &:not(:first-of-type) {
    margin-left: -${STAR_OVERLAP_PX}px;
  }
`;

const StarSvg = styled.svg<{ $filled: boolean }>`
  width: 30px;
  height: 30px;
  flex-shrink: 0;
  display: block;

  path {
    fill: ${(p) => (p.$filled ? FILLED : EMPTY)};
  }
`;

export { RecruiterStars };
